import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateCase',
})
export class TruncateCasePipe implements PipeTransform {
  transform(value: string, maxLength: number, caseMode?: string): string {
    if (!value) return '';

    // Check if the value length exceeds the maxLength
    if (value.length > maxLength) {
      // Split the value into words
      const words = value.split(' ');
      // Initialize the truncated value
      if (words.length === 1) {
        return this.truncateSingleWord(words[0], maxLength, caseMode);
      }
      let truncatedValue = '';

      // Iterate through the words and add them to the truncated value until maxLength is reached
      for (const word of words) {
        if ((truncatedValue + word).length + 3 <= maxLength) {
          // Add the word and a space (3 characters) if it doesn't exceed maxLength
          truncatedValue += word + ' ';
        } else {
          // return this.truncateSingleWord(truncatedValue, maxLength, caseMode);
          // If adding the current word would exceed maxLength, stop and append '...'
          break;
        }
      }

      // Remove the trailing space and append '...'
      truncatedValue = truncatedValue.trim() + '...';

      // Apply the specified case transformation
      if (caseMode === 'upper') {
        truncatedValue = truncatedValue.toUpperCase();
      } else if (caseMode === 'lower') {
        truncatedValue = truncatedValue.toLowerCase();
      } else if (caseMode === 'title') {
        truncatedValue = truncatedValue
          .toLowerCase()
          .split(' ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      }

      return truncatedValue;
    } else {
      // Apply the specified case transformation to the whole value
      if (caseMode === 'upper') {
        return value.toUpperCase();
      } else if (caseMode === 'lower') {
        return value.toLowerCase();
      } else if (caseMode === 'title') {
        return value
          .toLowerCase()
          .split(' ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      } else {
        return value;
      }
    }
  }
  private truncateSingleWord(
    word: string,
    maxLength: number,
    caseMode: string
  ): string {
    if (word.length > maxLength) {
      // Truncate the single word accordingly
      let truncatedWord = word.substring(0, maxLength) + '...';

      // Apply the specified case transformation
      if (caseMode === 'upper') {
        truncatedWord = truncatedWord.toUpperCase();
      } else if (caseMode === 'lower') {
        truncatedWord = truncatedWord.toLowerCase();
      } else if (caseMode === 'title') {
        truncatedWord =
          truncatedWord.charAt(0).toUpperCase() + truncatedWord.slice(1);
      }

      return truncatedWord;
    } else {
      // Apply the specified case transformation to the whole single word
      if (caseMode === 'upper') {
        return word.toUpperCase();
      } else if (caseMode === 'lower') {
        return word.toLowerCase();
      } else if (caseMode === 'title') {
        return word.charAt(0).toUpperCase() + word.slice(1);
      } else {
        return word;
      }
    }
  }
}
